module.exports = __webpack_public_path__ + "img/LI-In-Bug.1b18d461.png";